import { memo, useCallback } from 'react'
import { IMediaItem } from 'types/media'
import * as Styled from '../styled'
import { PROJECT_MEDIA_TYPES } from 'consts'
import { MediaItemLoadingWrapper } from '../MediaItemLoading'
import { useItemClickHandler } from 'containers/Timeline/MainContainer/Tracks/hooks/use-item-click-handler'
import { isImagePath } from 'utils/media'
import { useGenerationProgress } from 'hooks/useGenerationProgress'
import { isBlobUrl } from 'utils'

interface ICanvasMediaItemProps {
  mediaItem: IMediaItem
  isVisible: boolean
  scale?: number
}

const CanvasMediaItem = ({
  mediaItem,
  isVisible,
  scale
}: ICanvasMediaItemProps) => {
  const { meta, type } = mediaItem
  const { path: mediaItemPath } = meta

  const isVideo =
    type === PROJECT_MEDIA_TYPES.video || type === PROJECT_MEDIA_TYPES.aiVideo

  const { progress, message } = useGenerationProgress({
    mediaItemId: mediaItem.id
  })

  const handler = useItemClickHandler()

  const handleMediaItemClick = useCallback(() => {
    handler({ id: mediaItem.id, type })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaItem.id, type])

  const isBlobImage = !isVideo && isBlobUrl(mediaItemPath)
  const isMetaPathImage = !!mediaItemPath && isImagePath(mediaItemPath)
  const isImage = isBlobImage || isMetaPathImage
  // before we had the loading item generation data, now we do not show the item loading state on the left tab
  // and thus do not keep the gen data in redux, so we need to rely only on the media item path
  const imagePath = isImage ? mediaItemPath : null

  return (
    <MediaItemLoadingWrapper
      mediaItem={mediaItem}
      isLoadingVisible
      isVisible={isVisible}
      mediaItemPath={imagePath}
      scale={scale}
      isVideo={isVideo}
      progress={progress}
      message={message}
    >
      {imagePath ? (
        <Styled.ImageInsideMediaFrame
          src={imagePath}
          onClick={handleMediaItemClick}
        />
      ) : null}
    </MediaItemLoadingWrapper>
  )
}

export default memo(CanvasMediaItem)
